<template>
  <section class="app-intro">
    <picture>
      <source media="(min-width: 768px)" type="image/webp" srcset="../assets/intro.webp">
      <source media="(min-width: 768px)" type="image/jpeg" srcset="../assets/intro.jpg">
      <source srcset="../assets/intro_min.webp" type="image/webp">
      <img src="../assets/intro_min.jpg" alt="安樂死專題標這裡" loading="lazy">
    </picture>
    <div class="intro__gradient" />
    <h1>他們<br>都求<br>安樂死</h1>
    <p>癌症末期、重度癱瘓、罕見疾病⋯⋯當這些病將一個人帶進生命末期，活著只是不斷承受痛苦時，想結束自己的生命，可不可以呢？現在雖有《安寧緩和醫療條例》和《病人自主權利法》，但有人寧願「搭快車」。</p>
    <p>安樂死是「人到底有沒有自主死亡權利？」的一場拔河。</p>
  </section>
</template>
<script>
export default {
  name: 'AppIntro'
}
</script>
<style lang="scss" scoped>
.app-intro {
  position: relative;
  padding: 94px calc((100% - 266px) / 2) 50px;
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 700px;
    padding: 0 120px 0;
  }
  @media (min-width: 1024px) {
    min-height: 900px;
    padding: 0;
  }
  picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    width: 100%;
    height: 80%;
    @media (min-width: 768px) {
      height: 100%;
    }
    @media (min-width: 1200px) {
      z-index: 0;
      object-position: 70% bottom;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 70% center;
    }
  }
  h1, p {
    position: relative;
    z-index: 0;
    @media (min-width: 1024px) {
      left: 15%;
    }
  }
  h1 {
    font-size: 46px;
    font-weight: 900;
    font-family: source-han-serif-tc,serif;
    line-height: normal;
    & + p {
      margin-top: 166px;
    }
    @media (min-width: 768px) {
      br {
        display: none;
      }
      & + p {
        margin-top: 100px;
      }
    }
    @media (min-width: 1024px) {
      font-size: 66px;
      line-height: 1.27;
      & + p {
        margin-top: 47px;
      }
    }
  }
  p {
    text-align: justify;
    @media (min-width: 768px) {
      max-width: 300px;
    }
    @media (min-width: 1024px) {
      max-width: 500px;
      font-size: 18px;
    }
    @media (min-width: 1200px) {
      max-width: 634px;
    }
  }
  .intro__gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255,0) 0%, rgba(255, 255, 255,0) 35%, rgba(255, 255, 255,1) 80%);
    @media (min-width: 768px) {
      background: linear-gradient(to bottom, rgba(255, 255, 255,0) 0%, rgba(255, 255, 255,0) 35%, rgba(255, 255, 255,1) 95%);
    }
  }
}
</style>
